import { MdExitToApp } from 'react-icons/md';
import { Button } from '@nbirl/nbi-common-ui-libs';

import { DashboardWorkbook } from '../../models';

type DashboardsWorkbookItemProps = {
  workbook: DashboardWorkbook;
  onWorkbookSelect: () => void;
};

export const DashboardsWorkbookItem = ({
  workbook,
  onWorkbookSelect,
}: DashboardsWorkbookItemProps) => (
  <div className="border border-solid border-primary-200 rounded-lg bg-primary-25 p-5">
    <h4 className="text-lg text-teal-500 font-medium mb-2 break-words">
      {workbook.name}
    </h4>
    <pre className="text-sm text-gray-400 mb-2 whitespace-pre-wrap break-words">
      {workbook.description}
    </pre>
    <Button
      variant="ghost"
      size="sm"
      className="-ml-1.5"
      rightIcon={<MdExitToApp />}
      onClick={onWorkbookSelect}
    >
      View
    </Button>
  </div>
);
